<template>
  <div class="calico-confirmation">
    <i
      v-if="confirm"
      class="bi bi-exclamation-triangle-fill contained-icon-large"
    />
    <i
      v-if="success"
      class="bi bi-check-lg contained-icon-large"
    />
    <i
      v-if="error"
      class="bi bi-x-lg contained-icon-large"
    />
    <h1 class="heading--large">
      {{ confirm || success || error }}
    </h1>
    <p class="body--medium">
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'CalicoConfirmation',
  props: {
    confirm: {
      type: String,
      default: ""
    },
    success: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    }
  },
  computed: {
    icon() {
      return this.confirm ? '' : this.success ? '' : this.error ? '' : ""
    }
  }
}
</script>

<style scoped lang="scss">
.calico-confirmation {
  @include stack-space($space-small);
  align-items: center;
  justify-content: center;
  padding: $space-xxlarge $space-large;

  .bi-x-lg {
    background-color: $color-semantics-error;
    border: none;
    color: $color-white;
  }

  .bi-check-lg {
    background-color: $color-green-dark;
    border: none;
    color: $color-white;
  }

  .bi-exclamation-triangle-fill {
    background-color: $color-orange;
    border: none;
    color: $color-white;
  }

  p {
    margin: 0;
    text-align: center;
  }
}
</style>